import { Response } from '@src/interface/api/response.interface'
import client from '@src/lib/api/client'

export interface SigninResponse extends Response {
	data: { vendor: SigninResult }
}

export type SigninResult = {
	no: string
	username: string
	status: string
	create_date: string
	modify_date: string
	delete_date: string | null
	role_no: string
	role: { no: string; role: string }
}

export const signin = async (username: string, password: string): Promise<SigninResponse> => {
	const response = await client.post<SigninResponse>(`/auth/signin`, {
		username,
		password,
	})

	return response.data
}
